import { Skeleton } from "src/@/components/ui/skeleton";

export function SkeletonChart() {
  return (
    <div className="flex flex-col space-y-2 bg-slate-200 w-full rounded-sm p-4">
      <Skeleton className="h-6 w-[150px] mb-4" />  {/* Title */}
      <Skeleton className="h-4 w-[100px] mb-6" />  {/* Subtitle */}
      <Skeleton className="h-[200px] w-full rounded-md" />  {/* Chart Area */}
    </div>
  );
}
